import { soundToPlay } from "../sounds/sound";
import Character from "./Character";

export class Rogue extends Character {

    firstSkill(enemyArr: Character[], enemiesIndex: number) {
        this.decSkillsCooldown()
        this.setSkillCooldown(1, 2)
        const atk = this.getAttack() + 3
        if (atk > enemyArr[enemiesIndex].getArmor()) {
            const dmg = (this.getDamage() + this.calcMod(this.getDex()))
            enemyArr[enemiesIndex].setHp(enemyArr[enemiesIndex].getHp() - dmg)
            soundToPlay("damageDeal")
        }
    }

    secondSkill(enemyArr: Character[], enemiesIndex: number): void {
        this.decSkillsCooldown()
        this.setSkillCooldown(2, 3)
        soundToPlay("damageDeal")
        const dmg = 2 * (this.getDamage() + this.calcMod(this.getDex()))
        enemyArr[enemiesIndex].setHp(enemyArr[enemiesIndex].getHp() - dmg)
    }

    thirdSkill(enemyArr: Character[], enemiesIndex: number): void {
        this.decSkillsCooldown()
        this.setSkillCooldown(3, 4)
        const dmg = 3 * (this.getDamage() + this.calcMod(this.getDex()))
        enemyArr[enemiesIndex].setHp(enemyArr[enemiesIndex].getHp() - dmg)
        soundToPlay("damageDeal")
    }
}